<template>
  <div class="app-voucherbox" :class="getSlotText('colour')" v-if="!voucherCode && getSlotText('voucherCode')">
    <SimonModal
      :is-visible="showInfoModal"
      @hide="showInfoModal = false"
    >
      <template v-slot:modalTitle>
        <h2><slot name="voucherCode">dolor sit.</slot></h2>
      </template>
      <div v-html="getSlotText('txtInfoModal')"></div>
    </SimonModal>
    <div class="box--info">
      <div class="box--heading">
        <h3><slot name="headlinePre">Lorem ipsum</slot> <slot name="voucherCode">dolor sit.</slot></h3>
        <button @click="openInfoModal()" class="icon-only"><img height="22" width="22" :src="getSlotText('colour') === 'fill-white' ? 'files/flash/images/svg-icons/info-icon.svg' : 'files/flash/images/svg-icons/info-icon-white.svg'" :alt="getSlotText('lblInfoIcon')"></button>
      </div>
      <div><slot name="txtVoucherDescription">Lorem ipsum dolor sit.</slot></div>
    </div>
    <button type="button" class="outline" @click.prevent.stop="checkToken()"><slot name="btnText">Lorem</slot></button>
  </div>
</template>

<script>

import voucherConfig from '@/mixins/voucherConfig'
import trackingHandler from '@/mixins/trackingHandler'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'TokenHandler',
  components: {
    SimonModal
  },
  mixins: [
    voucherConfig,
    trackingHandler
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  data () {
    return {
      loading: false,
      showInfoModal: false
    }
  },
  mounted () {
  },
  computed: {
    voucherCode () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/voucherCode']
    },
    voucherPromotions () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/voucherPromotions']
    }
  },
  methods: {
    checkToken () {
      this.startLoader()
      this.loading = true
      this.clearToasts()
      this.$store.dispatch('checkoutv2/' + this.process + '/_cart/queryCart', { token: this.getSlotText('voucherCode') }).then((response) => {
        this.loading = false
        this.successToast(this.getSlotText('txtVoucherCodeRedeemed', 'voucher'))
        let trackingName = ''
        this.voucherPromotions.forEach(promo => {
          trackingName += promo.name + ','
        })
        this.$emit('open-collapse')
        this.trackData('voucher', {
          voucher_action: 'apply',
          voucher_code: this.getSlotText('voucherCode'),
          voucher_name: trackingName.slice(0, -1)
        })
        this.stopLoader()
      }, (error) => {
        this.loading = false
        this.errorToast(this.getErrorMessage(error))
        this.stopLoader()
        this.triggerErrorTracking(error, this.token)
      }).finally(() => {
        this.stopLoader()
      })
    },
    openInfoModal (token = this.getSlotText('voucherCode')) {
      this.showInfoModal = true
      this.trackData('information', {
        information_action: 'reveal',
        information_name: token.toLowerCase() + ' info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      })
    }
  }
}
</script>
